import { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PeopleList from './people/PeopleList';
import CompanyList from './companies/CompanyList';
import CarriersList from './carriers/CarriersList';
import DestinationsList from './destinations/DestinationsList';
import ImportersList from './importers/ImportersList';
import NotifiesList from './notifies/NotifiesList';
import AccountsList from './accounts/AccountsList';
import LocationsList from './locations/LocationsList';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} {...other}>
      {value === index && <Box sx={{ paddingTop: 3, paddingBottom: 3 }}>{children}</Box>}
    </div>
  );
}

function tabProps(index: number) {
  return {
    'id': `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

export default function EntitiesPage() {
  const [tab, setTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
          <Tab label="Accounts" {...tabProps(0)} />
          <Tab label="Companies" {...tabProps(1)} />
          <Tab label="People" {...tabProps(2)} />
          <Tab label="Carriers" {...tabProps(3)} />
          <Tab label="Destinations" {...tabProps(4)} />
          <Tab label="Notifies" {...tabProps(5)} />
          <Tab label="Importers" {...tabProps(6)} />
          <Tab label="Locations" {...tabProps(7)} />
        </Tabs>
      </Box>
      <TabPanel value={tab} index={0}>
        <AccountsList />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <CompanyList />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <PeopleList />
      </TabPanel>
      <TabPanel value={tab} index={3}>
        <CarriersList />
      </TabPanel>
      <TabPanel value={tab} index={4}>
        <DestinationsList />
      </TabPanel>
      <TabPanel value={tab} index={5}>
        <NotifiesList />
      </TabPanel>
      <TabPanel value={tab} index={6}>
        <ImportersList />
      </TabPanel>
      <TabPanel value={tab} index={7}>
        <LocationsList />
      </TabPanel>
    </Box>
  );
}
